import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line
  selector: '.kz-textbox'
})
export class KzTextboxDirective implements OnInit {
  enabled = false;
  className = 'kz-field--placeholder-shown';

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private renderer: Renderer2,

  ) {
  }

  ngOnInit() {
    if (this.renderer.parentNode(this.el.nativeElement) && this.renderer.parentNode(this.el.nativeElement).classList.contains('kz-field')
      && !this.renderer.parentNode(this.el.nativeElement).classList.contains('kz-field--not-animate')) {
      this.renderer.addClass(this.el.nativeElement.parentNode, 'kz-field--animate');
      this.enabled = true;
      this.animate();
    } else {
      this.enabled = false;
    }

  }

  @HostListener('focus')
  @HostListener('blur')
  @HostListener('ngModelChange') changes() {
    if (this.enabled) {
      this.animate();
    }
  }

  animate() {
    if (this.el.nativeElement.value && this.el.nativeElement.value !== '') {
      this.renderer.removeClass(this.el.nativeElement.parentNode, this.className);
    } else {
      this.renderer.addClass(this.el.nativeElement.parentNode, this.className);
    }
  }
}
